import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";
import Check from "../compoment/icon/Check";

interface FavoriteModalProps extends ModalProps {
  onHide: () => void;
}

const AddtoCart = (props: FavoriteModalProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      props.onHide();
    }, 3000); // 3 seconds

    return () => clearTimeout(timer); // cleanup on unmount
  }, [props.onHide]);
  return (
    <Modal
      {...props}
      backdrop="static"
      className={`favoriteModal`}
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div>
          <div>
            <Check />
          </div>
          <div className="header">
            Added to cart successfully
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



export default AddtoCart;
